import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/auth';

function PrivateRoute({ children, ...rest }) {
  const { signed, updateUserContext } = useAuth();
  const location = useLocation();

  useEffect(() => {
    updateUserContext();
  }, [location.pathname]);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        signed ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
